import React from 'react';
import PropTypes from 'prop-types';
import Tag from '4all-ui/components/Tag';
import { styles } from '4all-ui/styles';
import * as style from './style';

const MarketplacesTags = ({ marketplaces }) => {
  return (
    <style.TagList>
      {marketplaces.map(mktpc => (
        <Tag
          key={mktpc.id}
          id={`tag-mktpc-${mktpc.id}`}
          customStyles={{ width: 'max-content', fontSize: styles.fontSizes.SIZE_7 }}
        >
          {mktpc.name}
        </Tag>
      ))}
    </style.TagList>
  );
};

MarketplacesTags.propTypes = {
  marketplaces: PropTypes.array,
};

MarketplacesTags.defaultProps = {
  marketplaces: [
    {
      id: 0,
      name: 'Crédito Real',
    },
    {
      id: 1,
      name: '4all',
    },
    {
      id: 2,
      name: 'Grêmio',
    },
  ],
};

export default MarketplacesTags;



// WEBPACK FOOTER //
// ./src/components/MarketplacesTags/index.js